import * as React from 'react';
import {useAppDispatch} from 'app/store/hooks';
import {useAppSelector} from 'app/store/hooks';
import {login} from 'features/user/userSlice';
import PrivateLayout from './Private';
import PublicLayout from './Public';

export default (): JSX.Element => {
  const dispatch = useAppDispatch();
  const {isAuthenticated} = useAppSelector(store => store.user);

  React.useEffect(() => {
    const existingSessionToken = window.sessionStorage.getItem('Jwt-Token');
    if (!isAuthenticated && existingSessionToken) {
      dispatch(login({jwt: existingSessionToken}));
    }
  });

  if (!isAuthenticated) {
    return <PublicLayout />;
  }

  return <PrivateLayout />;
};
